import * as Yup from 'yup';

export interface IOrganizationAuctionDonorData {
	id: number;
	name: string;
	logo?: string;
	logoUrl: string | File;
}
export type AuctionFormValues = {
	images: File[] | string[];
	name: string;
	value: number | null;
	minBid: number | null;
	bidIncrement: number | null;
	buyNowPrice: number | null;
	categoryId: number | null;
	description: string;
	donors: IOrganizationAuctionDonorData[];
	isLiveAuction: boolean;
	status?: number | null;
};

export const initialValues: AuctionFormValues = {
	images: [],
	name: '',
	value: null,
	minBid: null,
	bidIncrement: null,
	buyNowPrice: null,
	categoryId: null,
	description: '',
	donors: [],
	isLiveAuction: false,
};

const MAX_INT_32 = 2147483647;
const MAX_ERROR_MSG = 'Maximum value is 2147483647';

export const validationSchema = Yup.object().shape({
	name: Yup.string().required('Name is required').trim(),
	categoryId: Yup.number().required('Category is required'),
	value: Yup.number()
		.nullable()
		.notRequired()
		.moreThan(0, 'Value must be greater than 0')
		.max(MAX_INT_32, MAX_ERROR_MSG),
	minBid: Yup.number()
		.required('Min Bid is required')
		.moreThan(0, 'Value must be greater than 0')
		.max(MAX_INT_32, MAX_ERROR_MSG),
	bidIncrement: Yup.number()
		.required('Bid Increment is required')
		.moreThan(0, 'Value must be greater than 0')
		.max(MAX_INT_32, MAX_ERROR_MSG),
	buyNowPrice: Yup.number()
		.nullable()
		.notRequired()
		.moreThan(0, 'Value must be greater than 0')
		.max(MAX_INT_32, MAX_ERROR_MSG),
});
